import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  const token = sessionStorage.getItem('token');

  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      })
    : req;

  const router = inject(Router);

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        void router.navigate(['/dashboard']);
      }
      return throwError(() => error);
    }),
  );
};

